import React, { useEffect, useRef, useState } from "react"
import PropTypes from 'prop-types'
import Button from 'react-bootstrap/Button'
import { PhoneNumberUtil, PhoneNumberFormat } from 'google-libphonenumber'
import { v4 as uuidv4 } from 'uuid'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import ZAFClient from "zendesk_app_framework_sdk";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { Translate } from "../../Components/Translator.jsx"
import { IsEmptyString, GetCallHistoryFromLocalStorage, LocalizedDateTime, NowInDateTimeFormatISO8601, TimeDifferenceInMinutesAndSeconds, BroadcastBuffered, ucfirst, explode } from "../../Components/GeneralFunctions.jsx"
import { ZendeskGetAutoActionOneMatch, ZendeskGetAutoActionNoMatch, ZendeskGetTicketInboundCallBody, ZendeskGetTicketInboundCallSubject, ZendeskGetTicketOutboundCallBody, ZendeskGetTicketOutboundCallSubject, ZendeskGetTicketInboundCallBrandPerDdi, ZendeskGetTicketInboundCallGroupPerDdi, ZendeskGetTicketInboundCallTagPerDdi, ZendeskGetTicketOutboundCallTag } from "./EmbeddedZendeskSupport.jsx"

import CallHistory from "../../Components/CallHistory.jsx"
import SpeedDials from "../../Components/SpeedDials.jsx"

import CopyNumberPng from '../../Assets/zendesk_copynumber.png'
import CompanyPng from '../../Assets/zendesk_company.png'
import ContactPng from '../../Assets/zendesk_contact.png'
import CallPng from '../../Assets/zendesk_call.png'
import CreateTicketPng from '../../Assets/zendesk_createticket.png'
import ClearCallPng from '../../Assets/zendesk_clearcall.png'
import CreateContactPng from '../../Assets/zendesk_createcontact.png'

const EmbeddedZendesk = (props) => {
  
  const [mRepainter, SetRepainter] = useState("")

  const [mZendeskTab, SetZendeskTab] = useState(localStorage.getItem("ZendeskTab") || "Search")

  const mZendeskClient = useRef(null);
  const [mZendeskError, SetZendeskError] = useState("")   
  const [mZendeskUserData, SetZendeskUserData] = useState(null) 
     
  const [mFrameOrigin, SetFrameOrigin] = useState("") 

  const [mBroadcastChannel, SetBroadcastChannel] = useState(new BroadcastChannel("cloudctiwebclient2024_zendesk"))

  useEffect(() => {
    mBroadcastChannel.addEventListener("message", function(event) {
      if (event.data === "repaint")
      {   
        console.log("mBroadcastChannel message repaint")
        setTimeout(() => {
          SetRepainter(uuidv4())
        }, 500)      
      }
    });

    const windowUrl = window.location.search;
    var params = new URLSearchParams(windowUrl);
    const origin = params.get("origin")
    if (!IsEmptyString(origin))
    {
      SetFrameOrigin(origin)
    }
    else
    {
      console.log("Phone app does not have the origin url parameter")
    }

    mZendeskClient.current = ZAFClient.init();
    if (mZendeskClient.current)
    {  
      mZendeskClient.current.context().then(function(context) {
        if (context.location === "top_bar")
        {
          //No idea where mySymbol is coming from
          mZendeskClient.current.set('iconSymbol', 'mySymbol') 
        } 
      });       
    }
    else
    {
      SetZendeskError("Failed to initialize Zendesk SDK")
    }
  }, []);   

  //ZENDESK API

  const ZendeskAPI_CreateTicket = async (zendeskid, zendeskname, number, extension, callid, callinbound, ddi, ddiname, starttime, answeredtime, endedtime) => 
  {
    try 
    {
        let starttimeiso8601 = ""
        try { starttimeiso8601 = !IsEmptyString(starttime) ? new Date(starttime).toISOString() : "" } catch {}

        let TicketBody = callinbound ? ZendeskGetTicketInboundCallBody() : ZendeskGetTicketOutboundCallBody() 
        TicketBody = TicketBody.replaceAll("<callid>",callid)
        TicketBody = TicketBody.replaceAll("<number>",number)
        TicketBody = TicketBody.replaceAll("<name>",zendeskname)
        TicketBody = TicketBody.replaceAll("<extension>",extension)
        TicketBody = TicketBody.replaceAll("<ddi>",ddi)
        TicketBody = TicketBody.replaceAll("<ddiname>",ddiname)
        TicketBody = TicketBody.replaceAll("<callstart>",starttimeiso8601)
        TicketBody = TicketBody.replaceAll("<calltime>",TimeDifferenceInMinutesAndSeconds(endedtime - starttime))
        TicketBody = TicketBody.replaceAll("<talktime>",TimeDifferenceInMinutesAndSeconds(endedtime - answeredtime))

        let TicketSubject = callinbound ? ZendeskGetTicketInboundCallSubject() : ZendeskGetTicketOutboundCallSubject() 
        TicketSubject = TicketSubject.replaceAll("<callid>",callid)
        TicketSubject = TicketSubject.replaceAll("<number>",number)
        TicketSubject = TicketSubject.replaceAll("<name>",zendeskname)
        TicketSubject = TicketSubject.replaceAll("<extension>",extension)
        TicketSubject = TicketSubject.replaceAll("<ddi>",ddi)
        TicketSubject = TicketSubject.replaceAll("<ddiname>",ddiname)
        TicketSubject = TicketSubject.replaceAll("<callstart>",starttimeiso8601)
        TicketSubject = TicketSubject.replaceAll("<calltime>",TimeDifferenceInMinutesAndSeconds(endedtime - starttime))
        TicketSubject = TicketSubject.replaceAll("<talktime>",TimeDifferenceInMinutesAndSeconds(endedtime - answeredtime))

        let TicketTag = ""
        let TicketBrandId = ""
        let TicketGroupId = ""
        if (callinbound)
        {
          const TagsPerDdi = ZendeskGetTicketInboundCallTagPerDdi()
          if (!IsEmptyString(TagsPerDdi))
          {
            let DefaultTicketTag = ""
            TagsPerDdi.split("\n").forEach(line => 
            {
              if (line.indexOf("=") < 1) return; // skip lines without =  

              const [identifier, values] = line.split("=");
              if (!IsEmptyString(identifier) && (identifier === ddi)) 
              {
                TicketTag = values.trim()
              }
              else if (identifier === "*")
              {
                DefaultTicketTag = values.trim()
              }

            });
            TicketTag = !IsEmptyString(TicketTag) ? TicketTag : DefaultTicketTag
          }

          const BrandsPerDdi = ZendeskGetTicketInboundCallBrandPerDdi()
          if (!IsEmptyString(BrandsPerDdi))
          {
            let DefaultTicketBrandId = ""
            BrandsPerDdi.split("\n").forEach(line => 
            {
              if (line.indexOf("=") < 1) return; // skip lines without =  

              const [identifier, value] = line.split("=");
              if (!IsEmptyString(identifier) && (identifier === ddi)) 
              {
                TicketBrandId = value.trim()
              }
              else if (identifier === "*")
              {
                DefaultTicketBrandId = value.trim()
              }

            });
            TicketBrandId = !IsEmptyString(TicketBrandId) ? TicketBrandId : DefaultTicketBrandId
          }

          const GroupsPerDdi = ZendeskGetTicketInboundCallGroupPerDdi()
          if (!IsEmptyString(GroupsPerDdi))
          {
            let DefaultTicketGroupId = ""
            GroupsPerDdi.split("\n").forEach(line => 
            {
              if (line.indexOf("=") < 1) return; // skip lines without =  

              const [identifier, values] = line.split("=");
              if (!IsEmptyString(identifier) && (identifier === ddi)) 
              {
                TicketGroupId = values.trim()
              }
              else if (identifier === "*")
              {
                DefaultTicketGroupId = values.trim()
              }

            });
            TicketGroupId = !IsEmptyString(TicketGroupId) ? TicketGroupId : DefaultTicketGroupId
          }
        }
        else
        {
          TicketTag = ZendeskGetTicketOutboundCallTag()
        }
        TicketTag = TicketTag.replaceAll("<callid>",callid)
        TicketTag = TicketTag.replaceAll("<number>",number)
        TicketTag = TicketTag.replaceAll("<name>",zendeskname)
        TicketTag = TicketTag.replaceAll("<extension>",extension)
        TicketTag = TicketTag.replaceAll("<ddi>",ddi)
        TicketTag = TicketTag.replaceAll("<ddiname>",ddiname)
        TicketTag = TicketTag.replaceAll("<callstart>",starttimeiso8601)
        TicketTag = TicketTag.replaceAll("<calltime>",TimeDifferenceInMinutesAndSeconds(endedtime - starttime))
        TicketTag = TicketTag.replaceAll("<talktime>",TimeDifferenceInMinutesAndSeconds(endedtime - answeredtime))

        const TicketTagSection = !IsEmptyString(TicketTag) ? ("\"tags\":[" + explode(TicketTag,',','','"').join(',') + "], ") : "";
        const TicketBrandSection = !IsEmptyString(TicketBrandId) ? ("\"brand_id\":" + TicketBrandId + ", ") : ""
        const TicketGroupSection = !IsEmptyString(TicketGroupId) ? ("\"group_id\":" + TicketGroupId + ", ") : ""

        const Ticket = "{\"ticket\": {\"requester_id\":\"" + zendeskid + "\", \"subject\": \"" + TicketSubject + "\", " + TicketTagSection + TicketBrandSection + TicketGroupSection + "\"comment\": {\"body\":\"" + TicketBody + "\", \"public\": false}}}"
        console.log("Ticket",Ticket)
        const response = await mZendeskClient.current.request({
            url: '/api/v2/tickets.json',
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            data: Ticket
        })
        return response.ticket 
    } 
    catch (error) 
    {
        console.error("Failed to create new ticket", error);

        let failreason = null
        if (error.responseJSON != null)
        {
          if (!IsEmptyString(error.responseJSON.details)) { failreason = JSON.stringify(error.responseJSON.details) }
          else if (!IsEmptyString(error.responseJSON.description)) { failreason = error.responseJSON.description }
          else if (!IsEmptyString(error.responseJSON.error)) { failreason = error.responseJSON.error }
        }
        toast.error("Failed to create new ticket" + (!IsEmptyString(failreason) ? ": " + failreason : ""))

        return null
    }
  }

  const ZendeskAPI_CreateUser = async (callnumber) => 
  {
    try 
    {
        const response = await mZendeskClient.current.request({
            url: '/api/v2/users.json',
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            data: "{ \"user\": { \"name\": \"Caller " + callnumber + "\", \"phone\": \"" + callnumber + "\"}}"
        })

        const user = response.user
        user.result_type = "user"
        return user      
    } 
    catch (error) 
    {
        console.error("Failed to create new user", error);

        let failreason = null
        if (error.responseJSON != null)
        {
          if (!IsEmptyString(error.responseJSON.details)) { failreason = JSON.stringify(error.responseJSON.details) }
          else if (!IsEmptyString(error.responseJSON.description)) { failreason = error.responseJSON.description }
          else if (!IsEmptyString(error.responseJSON.error)) { failreason = error.responseJSON.error }
        }
        toast.error("Failed to create new user" + (!IsEmptyString(failreason) ? ": " + failreason : ""))

        return null
    }
  }

  const ZendeskAPI_GetOpenTickets = async (userid) => {
    try 
    {
      const response = await mZendeskClient.current.request({
        url: `/api/v2/users/${userid}/tickets/requested.json`,
        type: "GET",
        headers: {
          "Accept": "application/json",
        },
      });

      console.log("Zendesk API GetOpenTickets response", userid, response)
      if ((response != null) && (response.tickets != null) && (response.tickets.length > 0))
      {
        return response.tickets.filter(ticket => ticket.status === "open")
      }
    }
    catch (error) 
    {
        console.error("Failed to get open tickets", error);
    }
    return []
  }

  const ZendeskAPI_OpenItem = (id,type) => {
    try
    {
      mZendeskClient.current.invoke("routeTo", type, id);
    } 
    catch (error) 
    {
        console.error("Failed to open item", error);

        let failreason = null
        if (error.responseJSON != null)
        {
          if (!IsEmptyString(error.responseJSON.details)) { failreason = JSON.stringify(error.responseJSON.details) }
          else if (!IsEmptyString(error.responseJSON.description)) { failreason = error.responseJSON.description }
          else if (!IsEmptyString(error.responseJSON.error)) { failreason = error.responseJSON.error }
        }
        toast.error("Failed to open item" + (!IsEmptyString(failreason) ? ": " + failreason : ""))

        return null
    }
  }

  const ZendeskAPI_SearchContact = async (phonenumber, recognitionBuffer) => {
    try 
    {
      const response = await mZendeskClient.current.request({
        url: `/api/v2/search.json?query=type:user phone:${phonenumber}`,
        type: "GET",
        headers: {
          "Accept": "application/json",
        },
      });

      console.log("Zendesk API SearchContact response", phonenumber, response)
      if (response.results.length > 0) 
      {
        response.results.map((match) => { 
          if (recognitionBuffer.filter((item) => item.id === match.id).length === 0)
          {
            recognitionBuffer.push(match) 
          }
        })
      }
    } 
    catch (error) 
    {
      console.error("Failed to search contact", error);
    }
  }

  //END OF ZENDESK API 

  const CheckRecognitionAndAutomaticActions = (aCall) =>
  {
    //Only do this on the primary tab
    if (props.PrimaryTab)
    {
      const lastcallid = localStorage.getItem("zendesk_lastcallid") || ""
      const lastcalleventid = localStorage.getItem("zendesk_lastcalleventid") || ""
      if (aCall.CallId !== lastcallid)
      {
        //this is the first event for this call      
        const inbound = aCall.Direction.toLowerCase() === "inbound"
        const number = inbound ? aCall.CallerNumber : aCall.CalledNumber

        let RecognitionBuffer = []
        localStorage.setItem("zendesk_lastcallid", aCall.CallId)
        localStorage.setItem("zendesk_lastcalleventid",props.LastCallEventId)
        PerformSearch(number, RecognitionBuffer).then(() => {      
          localStorage.setItem("zendesk_lastcallrecognition", JSON.stringify(RecognitionBuffer))           
          console.log("ZendeskRecognition localstorage after PerformSearch",localStorage.getItem("zendesk_lastcallrecognition"))
          localStorage.setItem("zendesk_lastcallselectedrecognitionindex", 0)

          SetCallHistoryRecognition() //sets localstorage zendesk_lastcallselectedrecognitionid
              
          TryAutomaticActions()  

          Repaint()
        }) 
      }
      else if (props.LastCallEventId !== lastcalleventid)
      {
        //this is not the first event for this call, but it is the first event for this call with this state
        localStorage.setItem("zendesk_lastcalleventid", props.LastCallEventId)
        TryAutomaticActions()
      }
    }
  }

  const CreateAndOpenTicket = (zendeskid, zendeskname, activecall)  => 
  {
    try 
    {
        const callid = activecall.CallId ?? ""
        const callinbound = (activecall.Direction ?? "").toLowerCase() === "inbound"
        const callnumber = callinbound ? (activecall?.CallerNumber ?? "") : (activecall?.CalledNumber ?? "")  
        const ddi = callinbound ? (activecall.CalledNumber ?? "") : "" 
        const ddiname = callinbound ? (activecall.CalledName ?? "") : ""
        const extension = activecall.DeviceNumber ?? ""

        let starttime = null
        try { starttime = !IsEmptyString(activecall?.StartTime) ? parseInt(activecall.AnswerTime,10) : null } catch {}
        let answeredtime = null
        try { answeredtime = !IsEmptyString(activecall?.AnswerTime) ? parseInt(activecall.AnswerTime,10) : null } catch {}
        let endedtime = null
        try { endedtime = !IsEmptyString(activecall?.EndTime) ? parseInt(activecall.EndTime,10) : null } catch {}

        ZendeskAPI_CreateTicket(zendeskid, zendeskname, callnumber, extension, callid, callinbound, ddi, ddiname, starttime, answeredtime, endedtime).then((ticket) => { if (ticket != null) { ZendeskAPI_OpenItem(ticket.id, "ticket") }})
    } 
    catch (error) 
    {
        console.error("Failed to create new ticket: ", error.message);
    }
  }

  const CreateAndOpenUser = (callnumber) => 
  {
    try 
    {
        ZendeskAPI_CreateUser(callnumber).then((user) => {
          if (user != null)
          {
              const RecognitionBuffer = [user]

              localStorage.setItem("zendesk_lastcallrecognition", JSON.stringify(RecognitionBuffer))           
              localStorage.setItem("zendesk_lastcallselectedrecognitionindex", 0)

              SetCallHistoryRecognition() //sets localstorage zendesk_lastcallselectedrecognitionid

              ZendeskAPI_OpenItem(user.id, user.result_type)   
          }   
        })
    } 
    catch (error) 
    {
        console.error("Failed to create new user: ", error);
    }
  }

  const CreateUserAndCreateAndOpenTicket = (callnumber,activecall) => 
  {
    try 
    {
        ZendeskAPI_CreateUser(callnumber).then((user) => {
          if (user != null)
          {
              const RecognitionBuffer = [user]

              localStorage.setItem("zendesk_lastcallrecognition", JSON.stringify(RecognitionBuffer))           
              localStorage.setItem("zendesk_lastcallselectedrecognitionindex", 0)

              SetCallHistoryRecognition() //sets localstorage zendesk_lastcallselectedrecognitionid

              CreateAndOpenTicket(user.id, user.name, activecall)
          }   
        })
    } 
    catch (error) 
    {
        console.error("Failed to create new user: ", error);
    }
  }

  const NextRecognition = (aEvent, aRecognition,aRecognitionSelectedIndex) =>
  {
    aEvent.stopPropagation()
    const CurrentIndex = aRecognitionSelectedIndex
    const NewIndex = CurrentIndex < aRecognition.length - 1 ? CurrentIndex + 1 : 0
    localStorage.setItem("zendesk_lastcallselectedrecognitionindex", NewIndex)
    SetCallHistoryRecognition()
    Repaint()
  }

  const PerformSearch = async (number,RecognitionBuffer) => 
  {
    try 
    {
      //New way
      const userLocale = navigator.language || navigator.userLanguage; // e.g., "en-NL"
      const defaultRegion = userLocale.split('-')[1]; // Extract "NL"

      const phoneUtil = PhoneNumberUtil.getInstance()
      const parsedNumber = phoneUtil.parse(number, defaultRegion)
      const InternationalFormat = phoneUtil.format(parsedNumber, PhoneNumberFormat.E164).replace("+","%2B")
      const NationalFormat = phoneUtil.format(parsedNumber, PhoneNumberFormat.NATIONAL)
           
      await ZendeskAPI_SearchContact(`*${InternationalFormat}*`, RecognitionBuffer)
      await ZendeskAPI_SearchContact(`*${NationalFormat}*`, RecognitionBuffer)
      
      //Old way 
      //const SearchNumber = number.slice(-7)
      //await ZendeskAPI_SearchContact(SearchNumber, RecognitionBuffer)       
    } 
    catch (error) 
    {
        console.error("Failed to parse phone number: ", error.message);
    }
  }

  const PreviousRecognition = (aEvent, aRecognition,aRecognitionSelectedIndex) =>
  {
    aEvent.stopPropagation()
    const CurrentIndex = aRecognitionSelectedIndex ?? 0
    const NewIndex = CurrentIndex > 0 ? CurrentIndex - 1 : aRecognition.length - 1
    localStorage.setItem("zendesk_lastcallselectedrecognitionindex", NewIndex)
    SetCallHistoryRecognition()
    Repaint()
  }

  const RecognitionSummary = (aRecognition,aRecognitionSelectedIndex) =>
  {
    const CurrentIndex = aRecognitionSelectedIndex + 1
    return <div align="right" style={{ color: "gray", paddingRight: "6px"}}>{CurrentIndex}/{aRecognition.length}</div>
  }

  const Repaint = () => 
  {
    console.log("Repaint")
    mBroadcastChannel.postMessage("repaint")
    SetRepainter(uuidv4())
  }
  
  const SetCallHistoryRecognition = () =>
  {
    try
    {
        const ActiveCallString = localStorage.getItem("newestcallevent")
        const ActiveCall = !IsEmptyString(ActiveCallString) ? JSON.parse(ActiveCallString) : null
        if (ActiveCall != null)
        {
            const RecognitionBufferString = localStorage.getItem("zendesk_lastcallrecognition") 
            const RecognitionBuffer = !IsEmptyString(RecognitionBufferString) ? JSON.parse(RecognitionBufferString) : null
            if ((RecognitionBuffer != null) && (RecognitionBuffer.length > 0))
            {
                const RecognitionBufferIndexString = localStorage.getItem("zendesk_lastcallselectedrecognitionindex")
                const RecognitionBufferIndex = RecognitionBufferIndexString != null ? parseInt(RecognitionBufferIndexString) : 0
                if (RecognitionBuffer.length > RecognitionBufferIndex)
                {
                  const script = {ScreenpopUrl: ZendeskScreenpopUrlCreate(RecognitionBuffer[RecognitionBufferIndex].id,RecognitionBuffer[RecognitionBufferIndex].result_type), Name: "Open " + ucfirst(RecognitionBuffer[RecognitionBufferIndex].result_type)}
                  props.OnSetHistoryCallRecognition(ActiveCall.CallId, RecognitionBuffer[RecognitionBufferIndex].name, "Zendesk", [script])
                }
            }
        }
    }
    catch {}
  }

  const TryAutomaticActions = () => 
  {
    const ActiveCallString = localStorage.getItem("newestcallevent")
    const ActiveCall = !IsEmptyString(ActiveCallString) ? JSON.parse(ActiveCallString) : null
    const Inbound = (ActiveCall?.Direction ?? "").toLowerCase() === "inbound"
    const Number = Inbound ? ActiveCall.CallerNumber : ActiveCall.CalledNumber

    const LastAutoExecutedCall = localStorage.getItem("zendesk_lastautoexecutedcall")
    const AutoExecuteOnState = localStorage.getItem("zendesk_setting_autoexecuteonstate") 
    
    if ((ActiveCall == null) //no call
      || (LastAutoExecutedCall === ActiveCall.CallId) //the actions have already been executed for this call
      || ((AutoExecuteOnState === "answered") && (ActiveCall.State !== "answered")) //set to execute on answered, but state is not answered
      || ((AutoExecuteOnState === "ended") && (ActiveCall.State !== "ended"))) //set to execute on ended, but state is not ended
    {
      return
    }

    const RecognitionBufferString = localStorage.getItem("zendesk_lastcallrecognition") 
    const RecognitionBuffer = !IsEmptyString(RecognitionBufferString) ? JSON.parse(RecognitionBufferString) : null
    if (RecognitionBuffer == null)  //recognition not found yet
    {
      return
    }
    else if (RecognitionBuffer.length === 0)
    {
      const action = ZendeskGetAutoActionNoMatch()
      if (action === "createandshowuser")
      {
        CreateAndOpenUser(Number)
      }
      else if (action === "createandshowuserandticket")
      {
        CreateUserAndCreateAndOpenTicket(Number, ActiveCall)
      }
    }
    else if (RecognitionBuffer.length === 1)
    {
      const Recognition = RecognitionBuffer[0]
      const action = ZendeskGetAutoActionOneMatch()
      if (action === "showuser")
      {
        ZendeskAPI_OpenItem(Recognition.id, Recognition.result_type)
      }
      else if (action === "showopenticket")
      {
        ZendeskAPI_GetOpenTickets(Recognition.id).then((openTickets) => {
          if (openTickets.length === 1)
          {
            ZendeskAPI_OpenItem(openTickets[0].id, "ticket")
          }
          else if ((openTickets.length === 0) && (localStorage.getItem("zendesk_setting_createnewticket") === "1"))
          {
            CreateAndOpenTicket(Recognition.id, Recognition.name, ActiveCall)
          }
        })
      }   
      else if (action === "smarthandling")
      {
        ZendeskAPI_GetOpenTickets(Recognition.id).then((openTickets) => {
          if (openTickets.length === 1)
          {
            ZendeskAPI_OpenItem(openTickets[0].id, "ticket")
          }
          else if (openTickets.length === 0) 
          {
            CreateAndOpenTicket(Recognition.id, Recognition.name, ActiveCall)
          }
          else
          {
            ZendeskAPI_OpenItem(Recognition.id, Recognition.result_type)
          }
        })
      } 
      else if (action === "createandshowticket")
      {
        CreateAndOpenTicket(Recognition.id, Recognition.name, ActiveCall)
      }    
    }
    else if (RecognitionBuffer.length > 1) //auto-execute only when there is 1 match
    {
      console.log("Actions not automatically executed because there is more than one match")
      return
    }
    
    localStorage.setItem("zendesk_lastautoexecutedcall", ActiveCall.CallId)
  }

  const ZendeskScreenpopUrlCreate = (aIdentifier, aRecordType) => {
    return "embedded://zendesk." + aIdentifier + "." + aRecordType
  }
  
  const ZendeskScreenpopUrlExecute = (aUrl) => {
    const prefix = "embedded://";
    if (!aUrl.startsWith(prefix)) 
    {
      //This is a regular script, perhaps created earlier
      OpenPopup(aUrl)
    }
    else
    {
      const parts = aUrl.slice(prefix.length).split(".");
      if (parts.length > 0) 
      {
        if (parts[0] === "zendesk")
        {
          if (parts.length === 3)
          { 
            ZendeskAPI_OpenItem(parts[1],parts[2])
          }
          else
          {
            console.log("Invalid popup value: " + aUrl)
          }
        }
        else
        {
          console.log("Zendesk Embedded cannot execute scripts for embedded " + parts[0])
        }
      }
      else
      {
        console.log("Empty popup value")
      }
    }
  }

  //EVENTS

  const ZendeskTabChange = (aTab) =>
  {
    SetZendeskTab(aTab)
    localStorage.setItem("ZendeskTab",aTab)
  }

  //PAINT

  const PaintMultipleRecognition = (aRecognition,aRecognitionSelectedIndex) => 
  {
    const RecognitionSelectedIndex = aRecognitionSelectedIndex ?? 0
    const SelectedRecognition = aRecognition[RecognitionSelectedIndex]

    return <> 
      <div className="notification clickableshadow" style={{ padding: "6px"}} onClick={() => ZendeskAPI_OpenItem(SelectedRecognition.id, SelectedRecognition.result_type)}>
        <table style={{width: "100%"}}>
        <tr>
          <td width="48" valign="center"><img style={{ width: "48px"}} src={SelectedRecognition.result_type === "user" ? ContactPng : CompanyPng}/></td>
          <td width="10"/>
          <td width="*" valign="center"><b style={{ fontSize: "22px", fontWeight: "bolder"}}>{SelectedRecognition.name}</b></td>
          <td width="10"/>
          <td width="48" valign="center"><button style={{ width: "48px", height: "48px"}} onClick={(evt) => PreviousRecognition(evt, aRecognition,RecognitionSelectedIndex)}>&lt;</button></td>
          <td width="10"/>
          <td width="48" valign="center"><button style={{ width: "48px", height: "48px"}} onClick={(evt) => NextRecognition(evt, aRecognition,RecognitionSelectedIndex)}>&gt;</button></td>
        </tr>
        </table> 
      </div>
      {RecognitionSummary(aRecognition,RecognitionSelectedIndex)}
    </>
  }

  const PaintNotRecognized = () => 
  {
    return <div className="notification" style={{paddingTop: "18px", paddingBottom: "18px"}}>{Translate("Number not recognized")}</div>
  }

  const PaintSearchTab = (aActiveCall) =>
  {
    //Helper variables for repaint
    const callid = aActiveCall?.CallId ?? ""
    const callinbound = (aActiveCall?.Direction ?? "").toLowerCase() === "inbound"
    const callnumber = callinbound ? (aActiveCall?.CallerNumber ?? "") : (aActiveCall?.CalledNumber ?? "")  
    const calltime = LocalizedDateTime(aActiveCall?.StartTime ?? Date.now())

    let ZendeskRecognition = null
    try { ZendeskRecognition = JSON.parse(localStorage.getItem("zendesk_lastcallrecognition")) } catch {}
    const ZendeskRecognitionSelectedIndex = parseInt(localStorage.getItem("zendesk_lastcallselectedrecognitionindex") ?? 0)

    const error = !IsEmptyString(mZendeskError) ? mZendeskError : !IsEmptyString(props.PhoneApiError) ? Translate("Failed to subscribe for phone events") + <br/> + Translate("Error") + ": " + props.PhoneApiError: ""

    return <table width="100%" height="100%" cellPadding="0" cellSpacing="0">
    <tbody>
      <tr height="30">
        <td valign="top" align="left" className="padded10">
          {!IsEmptyString(error) ? <div className="notificationerror">{error}</div> :
          IsEmptyString(callid) ? <div className="notification" style={{paddingTop: "8px", paddingBottom: "8px"}}>{Translate("No incoming call information available")}</div> :
            <span>
              <div className="notification" style={{paddingTop: "8px", paddingBottom: "8px"}}>                          
                <b>{(callinbound ? Translate("Incoming call from") : Translate("Outgoing call to")) + " " + callnumber}</b>
                <br/>                                               
                <div className="smalltext">{calltime}</div>   
              </div>
              <CopyToClipboard text={callnumber}><img className="clickable" src={CopyNumberPng} title="Copy number" style={{ width: "40px", marginTop: "4px", cursor: "pointer"}}/></CopyToClipboard>
              <>&nbsp;<img className="clickable" src={CallPng} title="Call" style={{ width: "40px", marginTop: "4px", cursor: "pointer"}} onClick={() => props.OnMakeCall(callnumber)}/></>
              {(ZendeskRecognition !== null) && (ZendeskRecognition.length > 0) ? <>&nbsp;<img className="clickable" src={CreateTicketPng} title="Create ticket" style={{ width: "40px", marginTop: "4px", cursor: "pointer"}} onClick={() => CreateAndOpenTicket(ZendeskRecognition[0].id, ZendeskRecognition[0].name, aActiveCall)}/></> : <></>}
              {(ZendeskRecognition !== null) && (ZendeskRecognition.length === 0) ? <>&nbsp;<img className="clickable" src={CreateContactPng} title="Create contact" style={{ width: "40px", marginTop: "4px", cursor: "pointer"}} onClick={() => CreateAndOpenUser(callnumber)}/></> : <></>}
              {!IsEmptyString(callid) ? <>&nbsp;<img className="clickable" src={ClearCallPng} title="Clear call" style={{ width: "40px", marginTop: "4px", cursor: "pointer"}} onClick={() => props.OnClearCall()}/></> : <></>} 
            </span>
            } 
        </td>
      </tr> 
      <tr style={{ borderTop: "1px black solid"}}>
        <td valign="top" align="left" className="padded10">
          {IsEmptyString(error) && !IsEmptyString(callid) ? 
            <span>                                         
              {
                ZendeskRecognition === null ? "Searching for recognition" :
                ZendeskRecognition.length > 1 ? PaintMultipleRecognition(ZendeskRecognition,ZendeskRecognitionSelectedIndex) : 
                ZendeskRecognition.length > 0 ? PaintSingleRecognition(ZendeskRecognition[0]) : 
                PaintNotRecognized() 
              }
            </span> 
            : <></>
            } 
        </td>
      </tr> 
      </tbody>
    </table>
  }

  const PaintSingleRecognition = (aRecognition) => 
  {
    return <div className="notification clickableshadow" style={{ padding: "6px"}} onClick={() => ZendeskAPI_OpenItem(aRecognition.id, aRecognition.result_type)}>
        <table>
        <tr>
          <td width="48" valign="center"><img style={{ width: "48px"}} src={aRecognition.result_type === "user" ? ContactPng : CompanyPng}/></td>
          <td width="10"/>
          <td width="*" valign="center"><b style={{ fontSize: "22px", fontWeight: "bolder"}}>{aRecognition.name}</b></td>
        </tr>
      </table> 
    </div>
  }

  //Get the latest call, if one exists
  let ActiveCall = null
  try
  {
    const ActiveCallString = localStorage.getItem("newestcallevent")
    ActiveCall = !IsEmptyString(ActiveCallString) ? JSON.parse(ActiveCallString) : null
    if ((ActiveCall != null) && !IsEmptyString(ActiveCall.CallId))
    {
      CheckRecognitionAndAutomaticActions(ActiveCall)
    }
  }
  catch {}

  return <table width="100%" height="100%">        
    <tbody>
    <tr height="24">
        <td width="33%" className={mZendeskTab === "Search" ? "mobilemodewindow mobilemodewindowselected zendesktabselected" : "mobilemodewindow"} onClick={() => ZendeskTabChange("Search")}><span className={mZendeskTab === "Search" ? "up3px zendesktabselected" : "up3px"}>{Translate("Search").toUpperCase()}</span></td>
        <td width="34%" className={mZendeskTab === "History" ? "mobilemodewindow mobilemodewindowselected zendesktabselected" : "mobilemodewindow"} onClick={() => ZendeskTabChange("History")}><span className={mZendeskTab === "History" ? "up3px zendesktabselected" : "up3px"}>{Translate("History").toUpperCase()}</span></td>
        <td width="33%" className={mZendeskTab === "Speed dial" ? "mobilemodewindow mobilemodewindowselected zendesktabselected" : "mobilemodewindow"} onClick={() => ZendeskTabChange("Speed dial")}><span className={mZendeskTab === "Speed dial" ? "up3px zendesktabselected" : "up3px"}>{Translate("Speed dial").toUpperCase()}</span></td>
    </tr>
    <tr><td colSpan="3"><ToastContainer/></td></tr>
    <tr height="*">

        {mZendeskTab === "Search" ? 

            <td colSpan="3" valign="top">       
              {PaintSearchTab(ActiveCall)}
            </td>

        : (mZendeskTab === "History" ? 

            <td colSpan="3" align="left" valign="top">
              <CallHistory 
                Calls={props.Calls}
                QueryingRecognitionNumbers={props.RecognitionCacheQueryingNumbers}
                SpeedDials={((props.SpeedDials === undefined) || (props.SpeedDials === null) || !props.SpeedDials) ? [] : props.SpeedDials} 
                ShowHeader={false} 
                AddSearch={true}
                OnMakeCall={(number, name, application, scripts) => props.OnMakeCall(number, name, application, scripts)} 
                OnAddToSpeedDial={(number, name, application, scripts) => props.OnAddToSpeedDial(number, name, application, scripts)}
                OnRemoveFromSpeedDial={(number) => props.OnRemoveFromSpeedDial(number)} 
                OnRemoveFromCallHistory={(callid) => props.OnRemoveFromCallHistory(callid)}
                OnEmbeddedScreenpop={(url) => ZendeskScreenpopUrlExecute(url)}
              />
            </td>

        :

            <td colSpan="3" align="left" valign="top">                      
              <SpeedDials 
                SpeedDials={((props.SpeedDials === undefined) || (props.SpeedDials === null) || !props.SpeedDials) ? [] : props.SpeedDials} 
                ShowHeader={false} 
                OnMakeCall={(number, name, application, scripts) => props.OnMakeCall(number, name, application, scripts)} 
                OnRemoveFromSpeedDial={(number) => props.OnRemoveFromSpeedDial(number)}
              />
            </td>)
          }
    </tr>
    </tbody>
    </table>
}

EmbeddedZendesk.propTypes = {
  Calls: PropTypes.array,
  SecurityToken: PropTypes.string,
  PhoneApiError: PropTypes.string,
  LastCallEventId: PropTypes.string, //used for repainting purposes. updates on call event
  RecognitionCacheQueryingNumbers: PropTypes.array,
  SpeedDials: PropTypes.array,
  PrimaryTab: PropTypes.bool,
  Brand: PropTypes.string,
  OnAddToSpeedDial: PropTypes.func,
  OnClearCall: PropTypes.func,
  OnMakeCall: PropTypes.func,
  OnRemoveFromCallHistory: PropTypes.func,
  OnRemoveFromSpeedDial: PropTypes.func,
  OnSetHistoryCallRecognition: PropTypes.func
}

export default EmbeddedZendesk